import { render, staticRenderFns } from "./ed-context-menu-blank.vue?vue&type=template&id=44def8c3&"
import script from "./ed-context-menu-blank.ts?vue&type=script&lang=ts&"
export * from "./ed-context-menu-blank.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports